import { EstadosPreagendamientoEnumChoice, ModulosEnumChoice, a11yProps, sizeTab, texto, useCheckPermissions } from "@/shared";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomTabPanel } from "../..";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import PreAgendamientoTablaComponente from "./shared/componente/PreAgendamientoTablaComponente";
import PreagendamientoGeneralPage from "./page/preagendas-rechazadas/PreagendamientoRechazadoPage";

const PreAgendamientosPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);

  // Obtener username y rol del estado global

  //STATE
  const [valueTab, setValueTab] = useState(0);
  const setFaseVenta = useDiccionarioMotivo().setFaseVenta

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.PREAGENDAMIENTO);
  }, [])


  return (
    <SingleTableBoxScene
      title={"Preagendadas"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preagendamiento"
          >
            <Tab label={'Preagendadas'} {...a11yProps(0)} />
            <Tab label={'Finalizadas'} {...a11yProps(1)} />
            <Tab label={texto.cancelado} {...a11yProps(2)} />
          </Tabs>
          {/*estoy renderizando el chat historial*/}

        </Box>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <PreAgendamientoTablaComponente
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.EN_ESPERA} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <PreagendamientoGeneralPage
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.FINALIZADO} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <PreagendamientoGeneralPage
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.CANCELADO} />
      </CustomTabPanel>

    </SingleTableBoxScene>
  );
}

export default PreAgendamientosPage;